/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import { InvitationData } from 'types/Invitation';
import LinkInvitationFooter from '../Footer';

type LinkInvitationStep3Props = {
  invitationData: InvitationData | null;
  onNext: ( values:any ) => void
  handleSubmitNda: ( ) => void
};

function LinkInvitationStep3( {
  onNext, invitationData,
  handleSubmitNda,
}: LinkInvitationStep3Props ) {
  useEffect( () => {
    handleSubmitNda();
  }, [] );
  return (
    <>
      <h2 className="text--black5 text-center">Acuerdo de confidencialidad</h2>

      {invitationData?.ndaEstado !== 'COMPLETADO' && (
      <p className="mt-4 pt-2">
        Para continuar, es necesario la aceptación por
        su parte de un Acuerdo de Confidencialidad con Impar Capital.
        <br />
        <br />
        Por favor, lea atentamente el documento. Su aceptación implica el compromiso de mantener
        la información compartida bajo estricta confidencialidad.
        <br />

      </p>
      )}

      <LinkInvitationFooter
        onNext={onNext}
      />

    </>
  );
}

export default LinkInvitationStep3;
